import React, { Component } from 'react'
import {InfoBlockGrid} from '../InfoBlockGrid'
import Img from 'gatsby-image'
import {Grid} from '../Grid'
import {Title} from '../Title'
import {withPrefix} from 'gatsby-link'

import './journals.css'

const nJournalsPerRow = 3;
const nJournalsPerRowMobile = 1;

class Journals extends Component {

  render () {

    let images = this.props.data.journals.map(
      (datum, index) =>
          <a href={datum.href} target="_blank">
            <img src={datum.src}/>
          </a>
    );

    return (
      <div>

        <Title name = {this.props.data.title}></Title>

        <div style={{marginBottom: -20}}>
          <Grid
            nCellsPerRow = {nJournalsPerRow}
            nCellsPerRowMobile = {nJournalsPerRowMobile}
            marginLeft = {0}
            data = {images}>
          </Grid>
        </div>

      </div>
    );
  }
}


export default {Journals}



// WEBPACK FOOTER //
// ./src/components/Journals/index.js